import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { useMutation } from "@tanstack/react-query";
import { ReactNode } from "react";

interface GetVentaAuthorizationRequest {
    password: string
}

export async function getVentaAuthorization(request: GetVentaAuthorizationRequest): Promise<string> {
    await sleep(1000);
    const response = await api.post("ventas/authorization", request);
    return response.data;
}

export function useGetVentaAuthorizationMutation(mutationConfig: MutationConfig<string, GetVentaAuthorizationRequest> = {}) {
    return useMutation({
        ...mutationConfig,
        mutationFn: async (request) => await getVentaAuthorization(request)
    })
}

export interface GetVentaAuthorizationMutationProps {
    mutationConfig?: MutationConfig<string, GetVentaAuthorizationRequest>,
    children?: (mutationResult: MutationResult<string, GetVentaAuthorizationRequest>) => ReactNode
}

export function GetVentaAuthorizationMutation({
    children,
    mutationConfig
}: GetVentaAuthorizationMutationProps) {
    const mutationResult = useGetVentaAuthorizationMutation(mutationConfig);
    return children && children(mutationResult)
}